import styled from 'styled-components'

import ReklaimModal from 'components/ReklaimModal'
import { COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const TopReklaimModal = styled(ReklaimModal)`
  z-index: 9999;
`

export const ModalDescription = styled.div`
  font-size: 18px;
  margin: 10px 0 20px;
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`

export const Button = styled(RoundedButton)`
  width: 100%;
  margin-top: 30px;
`

export const ErrorText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${COLOURS.tiaMaria};
`

export const SpinnerContainer = styled.div`
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const IdentifierContainer = styled.div`
  display: inline-block;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid ${COLOURS.secondaryPurple1};
  color: ${COLOURS.secondaryPurple1};
  margin-bottom: 14px;
`

// EmailAddressAddConfirmation
export const CenteredContainer = styled.div`
  text-align: center;
`

export const EmailText = styled.span`
  color: ${COLOURS.secondaryPurple1};
  word-break: break-word;
`

export const ResendEmailContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 100px;
`

export const ResendEmailButton = styled.button`
  font-size: 16px;
  color: ${COLOURS.primaryBlue};
  font-weight: bold;
  border: none;
  background: none;
  transition: opacity 0.3s;

  &:disabled {
    font-weight: normal;
  }

  &:hover:not(:disabled) {
    opacity: 0.7;
  }
`

export const FooterText = styled.div`
  font-size: 16px;
`

export const FooterButton = styled.button`
  font-size: 16px;
  color: ${COLOURS.primaryBlue};
  font-weight: bold;
  border: none;
  background: none;
  transition: opacity 0.3s;

  &:disabled {
    font-weight: normal;
  }

  &:hover:not(:disabled) {
    opacity: 0.7;
  }
`
